'use client'

import { Button } from '@graftcode/design-system'

import styles from './DialogFooter.module.scss'

interface DialogFooterProps {
  cancelLabel: string
  confirmLabel: string
  cancelTestId?: string
  confirmTestId?: string
  confirmVariant?: 'primary' | 'danger'
  disabled?: boolean
  loading?: boolean
  onCancel: () => void
  onConfirm?: () => void
}

export function DialogFooter({
  cancelLabel,
  confirmLabel,
  cancelTestId,
  confirmTestId,
  confirmVariant = 'primary',
  disabled,
  loading,
  onCancel,
  onConfirm,
}: DialogFooterProps) {
  const isSubmit = !onConfirm

  return (
    <div className={styles.root}>
      <Button
        type="button"
        variant="outlined"
        size="m"
        className={styles.button}
        disabled={loading}
        onClick={onCancel}
        data-testid={cancelTestId}
      >
        {cancelLabel}
      </Button>
      <Button
        type={isSubmit ? 'submit' : 'button'}
        variant={confirmVariant}
        size="m"
        className={styles.button}
        disabled={disabled || loading}
        loading={loading}
        onClick={onConfirm}
        data-testid={confirmTestId}
      >
        {confirmLabel}
      </Button>
    </div>
  )
}
